/* eslint-disable no-restricted-syntax */

import '../utilities/string-extensions';

let isLocalStorageAvailable;
try {
  const key = '__isLocalStorageAvailable';
  sessionStorage.setItem(key, 1);
  sessionStorage.removeItem(key);
  isLocalStorageAvailable = true;
} catch (ex) {
  isLocalStorageAvailable = false;
}

const getLocalStorageKey = (coursePath, key) => `${coursePath}#${key}`;

export class Cache {
  static get(prefix, key) {
    if (isLocalStorageAvailable) {
      const storageKey = getLocalStorageKey(prefix, key);
      return JSON.parse(sessionStorage.getItem(storageKey));
    } else {
      Cache._nonLocalStorageCourseCache =
        Cache._nonLocalStorageCourseCache || {};
      Cache._nonLocalStorageCourseCache[prefix] =
        Cache._nonLocalStorageCourseCache[prefix] || {};
      return JSON.parse(Cache._nonLocalStorageCourseCache[prefix][key] || null);
    }
  }

  static set(prefix, key, value) {
    if (isLocalStorageAvailable) {
      const storageKey = getLocalStorageKey(prefix, key);
      sessionStorage.setItem(storageKey, JSON.stringify(value));
    } else {
      Cache._nonLocalStorageCourseCache =
        Cache._nonLocalStorageCourseCache || {};
      Cache._nonLocalStorageCourseCache[prefix] =
        Cache._nonLocalStorageCourseCache[prefix] || {};
      Cache._nonLocalStorageCourseCache[prefix][key] = JSON.stringify(value);
    }
  }

  static clear(prefix) {
    if (isLocalStorageAvailable) {
      const storageKeysToRemove = [];
      for (let i = 0; i < sessionStorage.length; i++) {
        const storageKey = sessionStorage.key(i);
        if (storageKey.startsWith(`${prefix}#`)) {
          storageKeysToRemove.push(storageKey);
        }
      }
      for (const storageKey of storageKeysToRemove) {
        sessionStorage.removeItem(storageKey);
      }
    } else {
      Cache._nonLocalStorageCourseCache =
        Cache._nonLocalStorageCourseCache || {};
      delete Cache._nonLocalStorageCourseCache[prefix];
    }
  }

  static clearCourses() {
    const courseRegex = /^(\w+\/)?courses\/\w+$/;
    if (isLocalStorageAvailable) {
      const storageKeysToRemove = [];
      for (let i = 0; i < sessionStorage.length; i++) {
        const storageKey = sessionStorage.key(i);
        const [firstSegment, ...otherSegments] = storageKey.split('#');
        if (otherSegments.length && firstSegment.match(courseRegex)) {
          storageKeysToRemove.push(storageKey);
        }
      }
      storageKeysToRemove.forEach((storageKey) => {
        sessionStorage.removeItem(storageKey);
      });
    } else {
      Cache._nonLocalStorageCourseCache =
        Cache._nonLocalStorageCourseCache || {};
      const topLevelKeysToRemove = [];
      Object.keys(Cache._nonLocalStorageCourseCache).forEach((key) => {
        if (key.match(courseRegex)) {
          topLevelKeysToRemove.push(key);
        }
      });
      for (const topLevelKey of topLevelKeysToRemove) {
        delete Cache._nonLocalStorageCourseCache[topLevelKey];
      }
    }
  }
}
